import { useNavigate } from "react-router-dom";
import arrow from "../assets/arrow.svg";
import CategoryStore from "../store/CategoryStore";
import CountryStore from "../store/CountryStore";
import CityStore from "../store/CityStore";

function CityBreadCrumb({ path }) {
  const country = CountryStore((state) => state.country);
  const navigate = useNavigate();
  const setGlobalCategory = CategoryStore((state) => state.setCategory);
  const category = CategoryStore((state) => state.category);
  const city = CityStore((state) => state.city);

  function handleCountryClick() {
    const formattedCountry = country.replace(/\s+/g, "-").toLowerCase();
    // console.log(formattedCountry);
    setGlobalCategory("");
    navigate(`/${formattedCountry}`);
  }

  function handleCityClick() {
    const formattedCountry = country.replace(/\s+/g, "-").toLowerCase();
    const formattedCategory = category.replace(/\s+/g, "-").toLowerCase();
    const formattedCity = city.replace(/\s+/g, "-").toLowerCase();
    // console.log(formattedCategory, formattedCountry);
    navigate(`/${formattedCountry}/${formattedCity}/${formattedCategory}`);
  }

  function handleCategoryClick() {
    if (city && city.length > 0) {
      handleCityClick();
      return;
    }
    const formattedCountry = country.replace(/\s+/g, "-").toLowerCase();
    const formattedCategory = category.replace(/\s+/g, "-").toLowerCase();
    console.log(formattedCategory, formattedCountry);
    navigate(`/${formattedCountry}/${formattedCategory}`);
  }

  return (
    <div className="flex flex-wrap items-center gap-2 text-sm text-[#4E5562] font-inter mb-4">
      <div className="flex items-center gap-2">
        <button
          onClick={() => navigate("/")}
          className="truncate max-w-[5rem] sm:max-w-none hover:underline hover:text-black"
        >
          Home
        </button>
        <img src={arrow} alt="arrow" className="w-4 h-4" />
      </div>
      <div className="flex items-center gap-2">
        <button
          onClick={handleCountryClick}
          className="truncate max-w-[5rem] sm:max-w-none hover:underline hover:text-black"
        >
          {country}
        </button>
        {category && <img src={arrow} alt="arrow" className="w-4 h-4" />}
      </div>
      {city && (
        <div className="flex items-center gap-2">
          <button
            onClick={handleCityClick}
            className="truncate max-w-[5rem] sm:max-w-none hover:underline hover:text-black"
          >
            {city}
          </button>
          <img src={arrow} alt="arrow" className="w-4 h-4" />
        </div>
      )}
      {category && (
        <div className="flex items-center gap-2">
          <button
            onClick={handleCategoryClick}
            className="truncate max-w-[5rem] sm:max-w-none hover:underline hover:text-black"
          >
            {category[0].toUpperCase() + category.slice(1)}
          </button>
          {path && <img src={arrow} alt="arrow" className="w-4 h-4" />}
        </div>
      )}
      <div className="text-gray-400 truncate max-w-[10rem] sm:max-w-[16rem] md:max-w-full">
        {path}
      </div>
    </div>
  );
}

export default CityBreadCrumb;